import React from 'react'
import intl from 'react-intl-universal'
import { locales } from 'locales'
import PropTypes from 'prop-types'
import renderReact from 'utils/renderReact'
import withBaseHelper from 'utils/withBaseHelper'
import ExternalLayout from 'layouts/ExternalLayout'
import { Button, FormGroup, Image } from 'components/qstrap'
import Input from 'components/shared/input/Input'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'

const propTypes = {
  locale: PropTypes.string,
  token_expired: PropTypes.string,
}

const defaultProps = {
  locale: 'en',
  token_expired: '',
}

export class ForgotPassword extends React.Component {
  constructor(props) {
    super(props)

    const currentLocale = this.props.locale

    intl.init({
      currentLocale,
      locales: {
        [currentLocale]: locales(currentLocale),
      },
    })

    this.state = {
      showAlert: false,
      emailSent: false,
      identifier: undefined,
      loading: false,
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.generateResetPasswordToken = this.generateResetPasswordToken.bind(this)
  }

  generateResetPasswordToken() {
    if (!this.state.identifier) { return }

    this.setState({ loading: true })

    const data = { identifier: this.state.identifier }
    const options = {
      headers: {
        'X-CSRF-Token': csrfToken(),
      },
    }

    API.post(API.endPoints().password.generate_reset_password_token, data, options).then(() => {
      this.setState({
        showAlert: false,
        emailSent: true,
        loading: false,
      })
    }).catch(() => {
      this.setState({
        showAlert: true,
        loading: false,
      })
    })
  }

  handleSubmit(e) {
    e.preventDefault()

    if (this.identifier.value) {
      this.setState({ identifier: this.identifier.value }, () => {
        this.generateResetPasswordToken()
      })
    }
  }

  renderExpiredTokenWarning() {
    if (this.props.token_expired) {
      return (
        <div className="alert alert-warning token-expired-warning m-y-md">
          {intl.get('forgot_password.token_expired')}
        </div>
      )
    }

    return ''
  }

  renderForm() {
    const alertClass = this.state.showAlert ? '' : 'hide'
    const loaderClass = this.state.loading ? '' : 'hide'

    return (
      <div className="p-a-md forgot-password-form">
        <h6>{intl.get('forgot_password.header')}</h6>

        {this.renderExpiredTokenWarning()}

        <div className="m-y-md">
          {intl.get('forgot_password.enter_user_info')}
        </div>

        <Input
          ref={c => this.identifier = c}
          name="identifier"
          containerClassName="m-a-0"
          icon="account"
          label={intl.get('forgot_password.user_info_label')}
        />

        <div className={`text-left m-b-0 m-t forgot-password-alert ${alertClass}`}>
          {intl.get('forgot_password.user_not_found')}
        </div>

        <FormGroup className="m-a-0 m-t-lg" check>
          <Button color="primary" type="submit" block onClick={this.handleSubmit} className="icon-loading-container" disabled={this.state.loading}>
            <i className={`icon icon-loading icon-loading-center ${loaderClass}`} ref={c => this.loader = c} />
            {intl.get('forgot_password.send_instructions')}
          </Button>
        </FormGroup>
      </div>
    )
  }

  renderEmailSentNotification() {
    const loaderClass = this.state.loading ? '' : 'hide'

    return (
      <div className="p-x-md p-y email-sent-notification">
        <div className="p-x-xl">
          <h6>{intl.get('forgot_password.instructions_sent')}</h6>

          <Image className="full-width p-y-lg" src="/assets/img/illustrations/email-sent.png" />
        </div>

        <div className="m-t-0 p-b bold">
          {intl.get('forgot_password.check_email')}
        </div>

        <div className="m-x-md m-t-xl m-b-0">
          {intl.get('forgot_password.email_not_received')}
        </div>

        <div className="m-x-md">
          {intl.get('forgot_password.click_to_resend')}
        </div>

        <FormGroup className="m-a-0 m-t-lg" check>
          <Button color="primary" type="submit" block onClick={this.generateResetPasswordToken} className="icon-loading-container" disabled={this.state.loading}>
            <i className={`icon icon-loading icon-loading-center ${loaderClass}`} ref={c => this.loader = c} />
            {intl.get('forgot_password.resend_instructions')}
          </Button>
        </FormGroup>
      </div>
    )
  }

  renderContent() {
    if (this.state.emailSent) {
      return this.renderEmailSentNotification()
    }
    return this.renderForm()
  }

  render() {
    return (
      <ExternalLayout id="external-container">
        {this.renderContent()}
      </ExternalLayout>
    )
  }
}

ForgotPassword.propTypes = propTypes
ForgotPassword.defaultProps = defaultProps

renderReact('ForgotPassword', withBaseHelper(ForgotPassword))
export default withBaseHelper(ForgotPassword)
